<template>
<div class="container">
    <h3 class="fw-bold">Delete Account</h3> 
    <ul class="list-inline p-2">
            <li class="list-inline-item">Name: {{full_name}} | </li>
            <li class="list-inline-item">Level: {{role}} | </li>
            <li class="list-inline-item">Expiry: {{end_date}} </li>      
    </ul> 
    <p class="fw-bold">We are sorry to see you go, but please note the following:</p> 
    <ul class="list-unstyled">
            <li class="p-1 text-muted">Your account will initially be deactivated for 30 days before it is permanently deleted.</li>
            <li class="p-1 text-muted">If you change your mind, log back into the Hunter &amp; Gold App during the 30 day deactivation period.</li>
            <li class="p-1 text-muted">Your account will be reactivated if you have any outstanding payments due or upcoming bookings.</li>
            <li class="p-1 text-muted">Your account cannot be recovered after deletion and any unused credit, rewards and loyalty points will be lost.</li>
            <li class="p-1 text-muted">Hunter &amp; Gold will only retain data which is required or permitted by law after deletion.</li>
    </ul>
    <div>
    <p class="fw-bold">Please let us know why you are leaving, so we can improve?</p> 
    <p class="fw-bold">Please provide at least one reason.</p> 
    <div class="container row">
     <div class="col-sm-3">
     </div>
     <div class="col-sm-6">
      <form class="pb-1" @submit="onSubmit">    
        <div class="mb-5">
        <select class="form-select" multiple  size="4" aria-label="reason" v-model="selectedReasons" required>
          <template v-for="reason in reasons" :key="reason.code">
          <option :value="reason.code" :title="reason.label" data-toggle="tooltip">{{ reason.label }}</option>
          </template>
        </select>
        </div>
        <div class="mb-4">
        <button class="btn btn-sm btn-danger" type="submit">
            <font-awesome-icon icon="trash" /> I understand, Delete My Account
        </button>
        <div class="d-flex flex-column p-2 align-items-center justify-content-center" v-if="loading">
            <div class="row">
              <div class="spinner-border" role="status">
              <span class="sr-only">Submitting...</span>
              </div>
            </div>
            <div class="row">
              <strong>Submitting... Please wait</strong>
            </div>
          </div>
        <button class="btn btn-dark btn-sm" @click="cancel">
            <font-awesome-icon icon="xmark" /> Cancel
        </button>
        <ul class="list-inline p-2">
          <li class="list-inline-item"><a href="https://www.huntergold.com/terms" target="_blank" class="link-secondary"><p class="text-muted fs-6"><small>Privacy Policy</small></p></a></li>
          <li class="list-inline-item">| </li>
          <li class="list-inline-item"><a href="https://www.huntergold.com/privacypolicy" target="_blank"  class="link-secondary"><p class="text-muted fs-6"><small>Terms &amp; Conditions</small></p></a></li>
        </ul>  
        </div>
      </form>
    </div>
    <div class="col-sm-3">
     </div>
    </div>
  </div>
</div>

</template>
<script>
import AccountService from "../services/account.service";
import CodeListService from "../services/code.service";


export default {
  name: 'Delete',

  props: ["data"],

  setup(props, { emit }) {
    
    const handleOnComplete = (message, isSuccess) => {
      emit("deleteEvent", {"message": message, "is_success": isSuccess});
    };

    return { handleOnComplete };
  },

  mounted() {  
    this.loadDeleteReasons();
  },

  data() {
    return {
      loading: false,
      reasons: [],
      selectedReasons: [],
      name: this.data.first_name,
      full_name: this.data.name,
      role: this.data.role,
      end_date: this.data.role_end_date,
      deleteMessage: "",
      deleteResponse:""
    };
  },

  methods: {
    onSubmit(event) {
      this.loading = true;
      event.preventDefault();
      this.deleteAccount();
    },
  
    loadDeleteReasons() {
      CodeListService.getDeleteReasons().then(
        (response) => {
          this.reasons = response;
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },

    deleteAccount() {
      AccountService.delete().then(
        (response) => {
          this.deleteMessage = ""; 
          this.deleteResponse = response.data.detail;

          AccountService.addReasons(this.selectedReasons).then(
        (response) => {
           this.loading = false;
           this.handleOnComplete(this.deleteResponse, true);
        },
        (error) => {
          this.loading = false;
          this.deleteMessage =
            (error.response &&
              error.response &&
              error.response.data.detail) ||
            error.response.data.detail ||
            error.response.data.detail.toString();
          
            this.handleOnComplete(error.response.data.detail, false);
        }
      );
        },
        (error) => {
          this.loading = false;
          this.deleteMessage =
            (error.response &&
              error.response &&
              error.response.data.detail) ||
            error.response.data.detail ||
            error.response.data.detail.toString();
          this.handleOnComplete(error.response.data.detail, false);
        }
      );
    },

    cancel() {
      if (localStorage.getItem("token") != null)
        localStorage.removeItem("token")

      this.$router.go('/');
    }
  }
}
</script>
<style scoped>
button { margin: 5px 5px 5px 5px } 
.btn-danger, .btn-danger:hover, .btn-danger:active, .btn-danger:visited {
    background-color:#EC1C24 !important;
}

option:before {
  white-space: break-spaces;
}
</style>
